import { Switch, useTheme } from "@mui/material";
import React from "react";

interface IBybVrSwitch {
  checked: boolean;
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const BybVrSwitch = ({ checked, onChange, ...props }: IBybVrSwitch) => {
  const theme = useTheme();
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      {...props}
      sx={{
        width: theme.spacing(6),
        height: theme.spacing(3.25),
        padding: 0,
        "& .MuiSwitch-switchBase": {
          margin: 0,
          padding: 0,
          transform: "translateX(0px)",
          "&.Mui-checked": {
            color: "#fff",
            transform: `translateX(${theme.spacing(2.75)})`,
            "& + .MuiSwitch-track": {
              backgroundColor: theme.palette.success.main,
              opacity: 1,
              border: 0,
            },
            "&.Mui-disabled + .MuiSwitch-track": {
              opacity: 0.5,
            },
          },
        },
        "& .MuiSwitch-thumb": {
          width: theme.spacing(2.5),
          height: theme.spacing(2.5),
          backgroundColor: theme.palette.common.white,
          margin: theme.spacing(0.4),
        },
        "& .MuiSwitch-track": {
          borderRadius: 31 / 2,
          backgroundColor: theme.palette.dsSurface.v500,
          opacity: 1,
          transition: "background-color 500ms",
        },
      }}
    />
  );
};

export default BybVrSwitch;
